module.exports = [
  {
    abbrev: 'AK',
    full: 'Alaska',
  },
  {
    abbrev: 'AL',
    full: 'Alabama',
  },
  {
    abbrev: 'AR',
    full: 'Arkansas',
  },
  {
    abbrev: 'AZ',
    full: 'Arizona',
  },
  {
    abbrev: 'CA',
    full: 'California',
  },
  {
    abbrev: 'CO',
    full: 'Colorado',
  },
  {
    abbrev: 'CT',
    full: 'Connecticut',
  },
  {
    abbrev: 'DE',
    full: 'Delaware',
  },
  {
    abbrev: 'FL',
    full: 'Florida',
  },
  {
    abbrev: 'GA',
    full: 'Georgia',
  },
  {
    abbrev: 'HI',
    full: 'Hawaii',
  },
  {
    abbrev: 'IA',
    full: 'Iowa',
  },
  {
    abbrev: 'ID',
    full: 'Idaho',
  },
  {
    abbrev: 'IL',
    full: 'Illinois',
  },
  {
    abbrev: 'IN',
    full: 'Indiana',
  },
  {
    abbrev: 'KS',
    full: 'Kansas',
  },
  {
    abbrev: 'KY',
    full: 'Kentucky',
  },
  {
    abbrev: 'LA',
    full: 'Louisiana',
  },
  {
    abbrev: 'MA',
    full: 'Massachusetts',
  },
  {
    abbrev: 'MD',
    full: 'Maryland',
  },
  {
    abbrev: 'ME',
    full: 'Maine',
  },
  {
    abbrev: 'MI',
    full: 'Michigan',
  },
  {
    abbrev: 'MN',
    full: 'Minnesota',
  },
  {
    abbrev: 'MO',
    full: 'Missouri',
  },
  {
    abbrev: 'MS',
    full: 'Mississippi',
  },
  {
    abbrev: 'MT',
    full: 'Montana',
  },
  {
    abbrev: 'NC',
    full: 'North Carolina',
  },
  {
    abbrev: 'ND',
    full: 'North Dakota',
  },
  {
    abbrev: 'NE',
    full: 'Nebraska',
  },
  {
    abbrev: 'NH',
    full: 'New Hampshire',
  },
  {
    abbrev: 'NJ',
    full: 'New Jersey',
  },
  {
    abbrev: 'NM',
    full: 'New Mexico',
  },
  {
    abbrev: 'NV',
    full: 'Nevada',
  },
  {
    abbrev: 'NY',
    full: 'New York',
  },
  {
    abbrev: 'OH',
    full: 'Ohio',
  },
  {
    abbrev: 'OK',
    full: 'Oklahoma',
  },
  {
    abbrev: 'OR',
    full: 'Oregon',
  },
  {
    abbrev: 'PA',
    full: 'Pennsylvania',
  },
  {
    abbrev: 'RI',
    full: 'Rhode Island',
  },
  {
    abbrev: 'SC',
    full: 'South Carolina',
  },
  {
    abbrev: 'SD',
    full: 'South Dakota',
  },
  {
    abbrev: 'TN',
    full: 'Tennessee',
  },
  {
    abbrev: 'TX',
    full: 'Texas',
  },
  {
    abbrev: 'UT',
    full: 'Utah',
  },
  {
    abbrev: 'VA',
    full: 'Virginia',
  },
  {
    abbrev: 'VT',
    full: 'Vermont',
  },
  {
    abbrev: 'WA',
    full: 'Washington',
  },
  {
    abbrev: 'WI',
    full: 'Wisconsin',
  },
  {
    abbrev: 'WV',
    full: 'West Virginia',
  },
  {
    abbrev: 'WY',
    full: 'Wyoming',
  },
  // Territories
  {
    abbrev: 'DC',
    full: 'Washington, D.C.',
  },
  {
    abbrev: 'GU',
    full: 'Guam',
  },
  {
    abbrev: 'MP',
    full: 'Northern Mariana Islands',
  },
  {
    abbrev: 'VI',
    full: 'Virgin Islands',
  },
  {
    abbrev: 'PR',
    full: 'Puerto Rico',
  },
  {
    abbrev: 'AS',
    full: 'American Samoa',
  },
];
